module.exports = __webpack_public_path__ + "media/images/icon__point--gained@2x-2dfabfcc2c296cad980c1f171d6a09cf.png";